<!-- <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text">
</p-confirmDialog> -->
<form [formGroup]="sendInviteForm" (ngSubmit)="onSubmit()">
  <div class="form-row">
    <div class="form-group col-md-4">
      <label>Company Name</label>
      <div>
        <input type="text" readonly class="form-control-plaintext" formControlName="companyName">
      </div>
    </div>
    <div class="form-group col-md-4">
      <label>Name</label>
      <div>
        <input type="text" readonly class="form-control-plaintext" formControlName="name">
      </div>
    </div>
    <div class="form-group col-md-4">
      <label>Communication Email ID</label>
      <div>
        <input type="text" readonly class="form-control-plaintext" formControlName="emailId">
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label class="required">User Name / ID</label>
      <input type="text" class="form-control" formControlName="userId" placeholder="User Name / ID" (focus)="autoGeneratedId=false;popover.close();" (keyup)="onChangeUserId()" ngbPopover="Recommended" [autoClose]="false" triggers="manual" #popover="ngbPopover"       placement="top-right" popoverClass="username-recommended-popover">
      <small *ngIf="sendInviteForm.get('userId').touched && sendInviteForm.get('userId').errors" class="p-error">
        <span *ngIf="sendInviteForm.get('userId').errors['required']">Required</span>
      </small>
      <lib-user-id-validation-library *ngIf="sendInviteForm.controls['userId'].dirty"
        [userId]="sendInviteForm.value.userId" [checkUserIdAvailability]="true" (isValid)="setUserIdValidity($event)" [isSystemGenerated]="autoGeneratedId">
      </lib-user-id-validation-library>
    </div>
  </div>
  <p-divider></p-divider>
  <button type="submit" [disabled]="sendInviteForm.invalid || !userIdValid" class="btn btn-primary pull-right">Send
    Invite</button>
</form>
